function makeOptions(correct, count = 3, range = 3) {
  const opts = new Set([correct]);
  while (opts.size < count) {
    let rand = correct + Math.floor(Math.random() * (2 * range + 1)) - range;
    if (rand !== correct && rand >= 0) opts.add(rand);
  }
  return Array.from(opts).sort(() => Math.random() - 0.5);
}

function generateOneChapterQuestion(topic) {
  let question = "";
  let correctAnswer;
  let options = [];

  if (topic === "numberConcepts") {
    // Ch1: Place value, addition, subtraction, multiplication
    const subTopic = Math.floor(Math.random() * 4); // Now 4 types
    if (subTopic === 0) {
      // Addition
      const a = Math.floor(Math.random() * 20) + 1;
      const b = Math.floor(Math.random() * 20) + 1;
      question = `${a} + ${b} = ?`;
      correctAnswer = a + b;
      options = makeOptions(correctAnswer, 3, 3);
    } else if (subTopic === 1) {
      // Subtraction
      let a = Math.floor(Math.random() * 20) + 1;
      let b = Math.floor(Math.random() * 20) + 1;
      if (b > a) [a, b] = [b, a];
      question = `${a} - ${b} = ?`;
      correctAnswer = a - b;
      options = makeOptions(correctAnswer, 3, 3);
    } else if (subTopic === 2) {
      // Multiplication (as repeated addition)
      const a = Math.floor(Math.random() * 5) + 2;
      const b = Math.floor(Math.random() * 5) + 2;
      question = `${a} × ${b} = ?`;
      correctAnswer = a * b;
      options = makeOptions(correctAnswer, 3, 5);
    } else {
      // Place Value (new!)
      const tens = Math.floor(Math.random() * 9) + 1; // 1-9
      const ones = Math.floor(Math.random() * 10);    // 0-9
      const number = tens * 10 + ones;
      if (Math.random() < 0.5) {
        // Ask value of a digit (tens or ones)
        if (Math.random() < 0.5) {
          // Tens place
          question = `What is the value of the ${tens} in ${number}?`;
          correctAnswer = tens * 10;
          options = makeOptions(correctAnswer, 3, 10);
        } else {
          // Ones place
          question = `What is the value of the ${ones} in ${number}?`;
          correctAnswer = ones;
          options = makeOptions(correctAnswer, 3, 5);
        }
      } else {
        // “How many tens and ones” format
        question = `${number} = __ tens + __ ones. What are the missing numbers?`;
        correctAnswer = `${tens} tens + ${ones} ones`;
        options = [
          `${tens} tens + ${ones} ones`,
          `${tens + 1} tens + ${ones} ones`,
          `${tens} tens + ${ones + 1} ones`
        ].sort(() => Math.random() - 0.5);
      }
    }
  } else if (topic === "patternsAlgebra") {
    // Ch2: Patterns, missing value (algebraic thinking)
    if (Math.random() < 0.5) {
      // Next in pattern
      const start = Math.floor(Math.random() * 5) + 2;
      const step = [2, 3, 5][Math.floor(Math.random() * 3)];
      const seq = [start, start + step, start + step * 2, start + step * 3];
      question = `What comes next? ${seq.join(", ")}, ___`;
      correctAnswer = start + step * 4;
      options = makeOptions(correctAnswer, 3, step * 2);
    } else {
      // Missing value
      const sum = Math.floor(Math.random() * 11) + 10; // 10-20
      const known = Math.floor(Math.random() * (sum - 1)) + 1;
      question = `What number makes this true: ${known} + __ = ${sum}?`;
      correctAnswer = sum - known;
      options = makeOptions(correctAnswer, 3, 3);
    }
  } else if (topic === "measurementGeometry") {
    // Ch3: Geometry, measurement, time, temperature
    const sub = Math.floor(Math.random() * 4);
    if (sub === 0) {
      // Shape sides
      const shapes = [
        { name: "triangle", sides: 3 },
        { name: "square", sides: 4 },
        { name: "circle", sides: 0 },
        { name: "pentagon", sides: 5 },
        { name: "hexagon", sides: 6 },
      ];
      const pick = shapes[Math.floor(Math.random() * shapes.length)];
      question = `How many sides does a ${pick.name} have?`;
      correctAnswer = pick.sides;
      options = makeOptions(correctAnswer, 3, 3);
    } else if (sub === 1) {
      // Time to next hour
      const hour = Math.floor(Math.random() * 12) + 1;
      const possibleMins = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
      const mins = possibleMins[Math.floor(Math.random() * possibleMins.length)];
      question = `It's ${hour}:${String(mins).padStart(2, '0')}. How many minutes until ${hour === 12 ? 1 : hour + 1}:00?`;
      correctAnswer = 60 - mins;
      options = makeOptions(correctAnswer, 3, 10);
    } else if (sub === 2) {
      // Temperature conversion
      const c = Math.floor(Math.random() * 11) + 10; // 10-20
      const f = Math.round((c * 9) / 5 + 32);
      if (Math.random() < 0.5) {
        question = `Convert ${c}°C to Fahrenheit (approx)?`;
        correctAnswer = f;
        options = makeOptions(correctAnswer, 3, 10);
      } else {
        question = `Convert ${f}°F to Celsius (approx)?`;
        correctAnswer = c;
        options = makeOptions(correctAnswer, 3, 5);
      }
    } else {
      // Length comparison
      const cm1 = Math.floor(Math.random() * 50) + 1;
      const cm2 = Math.floor(Math.random() * 50) + 1;
      if (cm1 === cm2) {
        question = `Which is bigger: ${cm1} cm or ${cm2} cm?`;
        correctAnswer = "They are equal";
        options = ["They are equal", `${cm1} cm`, `${cm2} cm`];
      } else {
        question = `Which is bigger: ${cm1} cm or ${cm2} cm?`;
        correctAnswer = cm1 > cm2 ? `${cm1} cm` : `${cm2} cm`;
        options = [correctAnswer, cm1 > cm2 ? `${cm2} cm` : `${cm1} cm`];
        while (options.length < 3) {
          const val = `${Math.floor(Math.random() * 50) + 1} cm`;
          if (!options.includes(val)) options.push(val);
        }
        options = options.sort(() => Math.random() - 0.5);
      }
    }
  } else if (topic === "dataProbability") {
    // Ch4: Probability words
    const scenarioPool = [
      {
        prompt: "Which word means 100% chance?",
        correct: "certain",
        distractors: ["likely", "impossible", "unlikely"],
      },
      {
        prompt: "Which word means 0% chance?",
        correct: "impossible",
        distractors: ["likely", "certain", "unlikely"],
      },
      {
        prompt: "Rolling a 6 on a fair 6-sided die is 1/6 chance. That is:",
        correct: "unlikely",
        distractors: ["certain", "impossible", "likely"],
      },
      {
        prompt: "Which word means more than 50% chance but not guaranteed?",
        correct: "likely",
        distractors: ["impossible", "certain", "unlikely"],
      },
    ];
    const pick = scenarioPool[Math.floor(Math.random() * scenarioPool.length)];
    question = pick.prompt;
    correctAnswer = pick.correct;
    options = [pick.correct, ...pick.distractors].sort(() => Math.random() - 0.5);
  } else if (topic === "financialLiteracy") {
    // Ch5: Money, saving, making change
    const subTopic = Math.floor(Math.random() * 4);
    if (subTopic === 0) {
      // Can you buy both?
      let have = [3, 4, 5, 6, 7, 8, 9][Math.floor(Math.random() * 7)];
      let toy = Math.floor(Math.random() * (have + 2)) + 1;
      let snack = Math.floor(Math.random() * (have + 2)) + 1;
      const total = toy + snack;
      question = `You have $${have}. A toy costs $${toy} and a snack costs $${snack}. Can you buy both?`;
      correctAnswer = (total <= have) ? "Yes" : "No";
      options = ["Yes", "No"];
    } else if (subTopic === 1) {
      // How many more dollars do you need?
      let cost = [5, 10, 12, 15, 20][Math.floor(Math.random() * 5)];
      let have = Math.floor(Math.random() * cost) + 1;
      question = `You want an item costing $${cost}, but only have $${have}. How many more dollars do you need?`;
      correctAnswer = cost - have;
      options = makeOptions(correctAnswer, 3, 3);
    } else if (subTopic === 2) {
      // Making change
      let paid = [5, 10, 20][Math.floor(Math.random() * 3)];
      let cost = Math.floor(Math.random() * paid) + 1;
      let change = paid - cost;
      question = `An item costs $${cost}. You pay $${paid}. How much change should you get?`;
      correctAnswer = change;
      options = makeOptions(change, 3, 3);
    } else {
      // Saving scenario: how many weeks needed?
      let itemCost = [8, 10, 15, 18, 20][Math.floor(Math.random() * 5)];
      let weeklySave = Math.floor(Math.random() * 5) + 1;
      question = `You want a $${itemCost} item. If you save $${weeklySave} each week, how many weeks do you need?`;
      let weeks = Math.ceil(itemCost / weeklySave);
      correctAnswer = weeks;
      options = makeOptions(weeks, 3, 3);
    }
  }

  // Fallback if no question was made
  if (!question) {
    question = "2 + 2 = ?";
    correctAnswer = 4;
    options = [4, 5, 3];
  }

  // Shuffle options if needed
  options = options.sort(() => Math.random() - 0.5);

  return { question, correctAnswer, options };
}

export function generateChapterQuiz(topic, count=10) {
  const qs = [];
  for (let i=0; i<count; i++) {
    qs.push(generateOneChapterQuestion(topic));
  }
  return qs;
}

export function generateAllTopicsQuestion() {
  const topics = ["numberConcepts","patternsAlgebra","measurementGeometry","dataProbability","financialLiteracy"];
  const pick = topics[Math.floor(Math.random() * topics.length)];
  return generateOneChapterQuestion(pick);
}

export function generateFinalQuiz(count=50) {
  const used = new Set();
  const questions = [];
  while (questions.length < count) {
    const q = generateAllTopicsQuestion();
    const key = `${q.question}::${q.correctAnswer}`;
    if (!used.has(key)) {
      used.add(key);
      questions.push(q);
    }
  }
  return questions;
}